import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MenuBtn from "../components/MenuBtn";

import "../App.css";

// display: "flex",
//flexFlow: "column nowrap",
// that the arrow in card is put to the bottom. we also need to add margin-top: auto directly to that arrow. I did that in App.css
// source: https://wpbeaches.com/aligning-last-item-bottom-container-flexbox/

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 500,
    background: "#aaaaaa0a",
    color: "#00ffebc4",
    height: "100%",
    display: "flex",
    flexFlow: "column nowrap",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: "white",
  },
}));

export default function RecipeReviewCard({
  missionName,
  missionDate,
  missionDetails,
  missionBadge,
  missionImage,
  loading,
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            <img
              src={loading ? "Loading" : missionBadge}
              alt="badge"
              style={{ width: "100%" }}
            />
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MenuBtn />
          </IconButton>
        }
        title={missionName}
        subheader={missionDate}
      />
      <CardMedia
        className={classes.media}
        image={loading ? "Loading" : missionImage}
        title="Paella dish"
      />
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          {missionDetails}
        </Typography>
      </CardContent>

      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>Mission Patch:</Typography>

          <Typography paragraph>
            <img src={loading ? "Loading" : missionBadge} alt="badge" />
          </Typography>
        </CardContent>
      </Collapse>
    </Card>
  );
}
